import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";

import styles from "./styles.m.css";

const cookies = new Cookies();
const coStat = cookies.get("Cookie_Status");

const Delayed = ({ children, waitBeforeShow = 800 }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(
    () => {
      setTimeout(() => {
        setIsShown(true);
      }, waitBeforeShow);
    },
    [waitBeforeShow]
  );

  return isShown ? children : null;
};

const CookieConsent = () => {
  const [state, setstate] = useState(false);

  if (coStat || state) return false;

  const handleCookiePolicy = () => {
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    cookies.set("Cookie_Status", true, { expires: nextWeek, domain: ".vikatan.com", path: "/" });
    setstate(true);
  };

  return (
    <Delayed>
      <div className={styles["cookieConsent"]}>
        <div className={styles["text-capitalize"]}>
          <p>
            விகடனின் பிரைவசி மற்றும் குக்கீ பாலிசிகளை ஏற்பதன் மூலம் உங்களுக்கு இத்தளத்தில் நிறைவான அனுபவம் கிடைப்பதை
            உறுதி செய்ய உதவுங்கள். நன்றி!
            <a href="https://www.vikatan.com/privacy-policy-web">
              <strong> பிரைவசி </strong>
            </a>
            <span>மற்றும்</span>
            <a href="https://www.vikatan.com/privacy-policy-web">
              <strong> குக்கீ பாலிசி</strong>
            </a>
          </p>
        </div>
        <button className={styles["btn-acc"]} onClick={() => handleCookiePolicy()}>
          I Accept
        </button>
      </div>
    </Delayed>
  );
};

export default CookieConsent;
